import { render, staticRenderFns } from "./vue-drag-resize.html?vue&type=template&id=5a7ee868&"
import script from "./vue-drag-resize.js?vue&type=script&lang=js&"
export * from "./vue-drag-resize.js?vue&type=script&lang=js&"
import style0 from "./vue-drag-resize.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports